import { useState } from "react";
import { Combobox } from "@headlessui/react";
import { getMapPageUrl } from "../utils";
import HighlightedText from "./HighlightedText";
import useDebounce from "../hooks/use-debounce";
import useSearchResults from "../hooks/use-search-results";
import usePlace from "../hooks/use-place";

export default function SearchBar() {
    const [term, setTerm] = useState("");
    const debouncedTerm = useDebounce(term, 300);
    const [selected, setSelected] = useState(null);
    const { data: results } = useSearchResults({ search: debouncedTerm });
    const { mutate: getPlace, isLoading } = usePlace();

    const handleFormSubmit = (e) => {
        e.preventDefault();

        if (results && results?.length > 0) {
            setSelected(results[0]);
            getPlace(
                { placeId: results[0].place_id },
                {
                    onSuccess: (data) =>
                        (window.location.href = getMapPageUrl({
                            place: data,
                            search: result[0]?.description,
                        })),
                }
            );
        }
    };

    const handlePlaceSelect = (value) => {
        setSelected(value);
        getPlace(
            { placeId: value.place_id },
            {
                onSuccess: (data) =>
                    (window.location.href = getMapPageUrl({
                        place: data,
                        search: value?.description,
                    })),
            }
        );
    };

    return (
        <form method="GET" className="search-bar" onSubmit={handleFormSubmit}>
            <Combobox
                value={selected?.description ?? ""}
                onChange={handlePlaceSelect}
            >
                <Combobox.Input
                    placeholder="Enter your postcode or city..."
                    onChange={(e) => setTerm(e.target.value)}
                    className="search-bar__input"
                    autoComplete="new-password"
                />
                <button
                    type="submit"
                    className="btn search-bar__submit-btn"
                    disabled={!results || results?.length < 1 || isLoading}
                >
                    Find a clinic
                </button>
                <Combobox.Options className="search-bar__results">
                    {results?.length > 0 &&
                        results.map((result) => (
                            <Combobox.Option
                                key={result.place_id}
                                value={result}
                                className="search-bar__result-item"
                            >
                                <HighlightedText
                                    target={term}
                                    value={result?.description}
                                />
                            </Combobox.Option>
                        ))}
                </Combobox.Options>
            </Combobox>
        </form>
    );
}
